import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "screen" }
const _hoisted_2 = { class: "box-login shadow" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "send btn btn-primary" }
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = { class: "send btn btn-primary" }
const _hoisted_10 = { class: "terms" }
const _hoisted_11 = { class: "terms-checkbox" }
const _hoisted_12 = { class: "checkbox-text" }
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "actions" }
const _hoisted_16 = { class: "send btn btn-primary" }
const _hoisted_17 = { class: "registered" }
const _hoisted_18 = { class: "icon" }

import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";
import { MD5 } from "crypto-js";

import { toast } from "@/common/utils/toast";
import { maskDateBR } from "@/common/utils/mask";

import { baseInput, svgIcon } from "@/common/components";

import { userRegister } from "@/common/api/rest/user";
import type { UserRegisterType } from "@/common/types/user";


export default /*@__PURE__*/_defineComponent({
  __name: 'register',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const hash = computed(() => {
  try {
    const decode = window.atob(String(route.query.hash));
    return JSON.parse(decode);
  } catch (_) {
    return null;
  }
});

const payload = ref<UserRegisterType>({
  name: "",
  birthdate: "",
  login: "",
  email: "",
  password: "",
  accepted_terms: false,
});

const confirmPassword = ref("");
const step = ref(1);

const error = ref<{ [key: string]: string }>({});

const passwordShow = ref(false);
const confirmPasswordShow = ref(false);

const termsLinks = computed(() => ({
  use: `https://www.segform.com.br/pt/term/terms-of-use`,
  privacy: `https://www.segform.com.br/pt/term/privacy-policy`,
}));

function isValid() {
  const { name, birthdate, email, password } = payload.value;

  error.value = {};

  if (step.value === 1) {
    if (name.trim().length === 0) error.value.name = t("error.required");

    if (birthdate.trim().length === 0)
      error.value.birthdate = t("error.required");
  }

  if (step.value === 2) {
    if (email.trim().length === 0) error.value.email = t("error.required");

    if (!email.includes("@")) error.value.email = t("error.invalid");
  }

  if (step.value === 3) {
    if (password.trim().length === 0)
      error.value.password = t("error.required");

    if (confirmPassword.value.trim().length === 0)
      error.value.confirm = t("error.required");

    if (password !== confirmPassword.value)
      error.value.confirm = t("error.not_equal");

    if (!payload.value.accepted_terms)
      error.value.accepted_terms = t("error.required");
  }

  return Object.keys(error.value).length === 0;
}

function formatLogin(value: string | null) {
  if (!value) return "";

  return value.toLowerCase().trim();
}

function goTo(url: string) {
  router.push(url);
}

function beforeStep() {
  router.push({
    path: "/auth/register",
    query: {
      hash: window.btoa(
        JSON.stringify({
          payload: payload.value,
          step: step.value - 1,
        }),
      ),
    },
  });
}

function nextStep() {
  if (!isValid()) return;

  router.push({
    path: "/auth/register",
    query: {
      hash: window.btoa(
        JSON.stringify({
          payload: payload.value,
          step: step.value + 1,
        }),
      ),
    },
  });
}

function updateTerms(value: any) {
  console.log("updateTerms", value);
}

function goToLogin() {
  router.push("/auth/login");
}

function submit() {
  if (!isValid()) return;

  userRegister({
    ...payload.value,
    password: MD5(payload.value.password).toString(),
  })
    .then((response) => {
      const { success, message } = response;
      if (success) {
        toast({ message: message, type: "success" });
        nextStep();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

watchEffect(() => {
  if (hash.value) {
    payload.value = { ...payload.value, ...hash.value.payload };
    step.value = hash.value.step;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require('@/assets/images/logo-512.png')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (step.value === 1)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("h2", null, _toDisplayString(_unref(t)("common.texts.register_account").toUpperCase()), 1),
              _createElementVNode("form", {
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (nextStep()), ["prevent"]))
              }, [
                _createVNode(_unref(baseInput), {
                  modelValue: payload.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event)),
                  value: payload.value.name,
                  placeholder: _unref(t)('common.placeholders.name'),
                  background: "#f1f1f1",
                  maxLength: "50"
                }, _createSlots({
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")), 1)
                  ]),
                  _: 2
                }, [
                  (error.value.name)
                    ? {
                        name: "error",
                        fn: _withCtx(() => [
                          _createTextVNode(_toDisplayString(error.value.name), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "value", "placeholder"]),
                _createVNode(_unref(baseInput), {
                  modelValue: payload.value.birthdate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payload.value.birthdate) = $event)),
                  value: payload.value.birthdate,
                  mask: _unref(maskDateBR),
                  background: "#f1f1f1",
                  minLength: "10",
                  maxLength: "10"
                }, _createSlots({
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.birthdate")), 1)
                  ]),
                  _: 2
                }, [
                  (error.value.birthdate)
                    ? {
                        name: "error",
                        fn: _withCtx(() => [
                          _createTextVNode(_toDisplayString(error.value.birthdate), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "value", "mask"]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", _hoisted_7, _toDisplayString(_unref(t)("common.labels.next")?.toUpperCase()), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "back btn btn-sm btn-default",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (goTo('/auth/login')))
                  }, _toDisplayString(_unref(t)("common.labels.back")?.toUpperCase()), 1)
                ])
              ], 32)
            ], 64))
          : _createCommentVNode("", true),
        (step.value === 2)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("h2", null, _toDisplayString(_unref(t)("common.texts.register_account").toUpperCase()), 1),
              _createElementVNode("form", {
                onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (nextStep()), ["prevent"]))
              }, [
                _createVNode(_unref(baseInput), {
                  modelValue: payload.value.login,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.login) = $event)),
                  value: payload.value.login,
                  placeholder: _unref(t)('common.placeholders.login'),
                  mask: formatLogin,
                  background: "#f1f1f1",
                  minLength: "5",
                  maxLength: "50"
                }, _createSlots({
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.login")), 1)
                  ]),
                  _: 2
                }, [
                  (error.value.login)
                    ? {
                        name: "error",
                        fn: _withCtx(() => [
                          _createTextVNode(_toDisplayString(error.value.login), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "value", "placeholder"]),
                _createVNode(_unref(baseInput), {
                  modelValue: payload.value.email,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((payload.value.email) = $event)),
                  value: payload.value.email,
                  placeholder: _unref(t)('common.placeholders.email'),
                  background: "#f1f1f1",
                  minLength: "8",
                  maxLength: "50"
                }, _createSlots({
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.email")), 1)
                  ]),
                  _: 2
                }, [
                  (error.value.email)
                    ? {
                        name: "error",
                        fn: _withCtx(() => [
                          _createTextVNode(_toDisplayString(error.value.email), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "value", "placeholder"]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", _hoisted_9, _toDisplayString(_unref(t)("common.labels.next")?.toUpperCase()), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "back btn btn-sm btn-default",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (beforeStep()))
                  }, _toDisplayString(_unref(t)("common.labels.back")?.toUpperCase()), 1)
                ])
              ], 32)
            ], 64))
          : _createCommentVNode("", true),
        (step.value === 3)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("h2", null, _toDisplayString(_unref(t)("common.texts.register_account").toUpperCase()), 1),
              _createElementVNode("form", {
                onSubmit: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (submit()), ["prevent"]))
              }, [
                _createVNode(_unref(baseInput), {
                  modelValue: payload.value.password,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((payload.value.password) = $event)),
                  placeholder: _unref(t)('common.placeholders.password'),
                  type: passwordShow.value ? 'text' : 'password',
                  background: "#f1f1f1",
                  maxLength: "50"
                }, _createSlots({
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.password")), 1)
                  ]),
                  sufix: _withCtx(() => [
                    (passwordShow.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "pointer",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (passwordShow.value = false))
                        }, [
                          _createVNode(_unref(svgIcon), {
                            icon: "eye",
                            size: "1.5rem"
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "pointer",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (passwordShow.value = true))
                        }, [
                          _createVNode(_unref(svgIcon), {
                            icon: "eye-closed",
                            size: "1.5rem"
                          })
                        ]))
                  ]),
                  _: 2
                }, [
                  (error.value.password)
                    ? {
                        name: "error",
                        fn: _withCtx(() => [
                          _createTextVNode(_toDisplayString(error.value.password), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "placeholder", "type"]),
                _createVNode(_unref(baseInput), {
                  modelValue: confirmPassword.value,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((confirmPassword).value = $event)),
                  placeholder: _unref(t)('common.placeholders.password'),
                  type: confirmPasswordShow.value ? 'text' : 'password',
                  background: "#f1f1f1",
                  maxLength: "50"
                }, _createSlots({
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.confirm_password")), 1)
                  ]),
                  sufix: _withCtx(() => [
                    (confirmPasswordShow.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "pointer",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (confirmPasswordShow.value = false))
                        }, [
                          _createVNode(_unref(svgIcon), {
                            icon: "eye",
                            size: "1.5rem"
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "pointer",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (confirmPasswordShow.value = true))
                        }, [
                          _createVNode(_unref(svgIcon), {
                            icon: "eye-closed",
                            size: "1.5rem"
                          })
                        ]))
                  ]),
                  _: 2
                }, [
                  (error.value.confirm)
                    ? {
                        name: "error",
                        fn: _withCtx(() => [
                          _createTextVNode(_toDisplayString(error.value.confirm), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["modelValue", "placeholder", "type"]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((payload.value.accepted_terms) = $event)),
                      type: "checkbox",
                      class: _normalizeClass(["checkbox-input", { 'has-error': error.value.accepted_terms }])
                    }, null, 2), [
                      [_vModelCheckbox, payload.value.accepted_terms]
                    ]),
                    _createElementVNode("span", _hoisted_12, [
                      _cache[17] || (_cache[17] = _createTextVNode(" Li e aceito os ", -1)),
                      _createElementVNode("a", {
                        href: termsLinks.value.use,
                        target: "_blank"
                      }, "Termos de Uso", 8, _hoisted_13),
                      _cache[18] || (_cache[18] = _createTextVNode(" e a ", -1)),
                      _createElementVNode("a", {
                        href: termsLinks.value.privacy,
                        target: "_blank"
                      }, " Política de Privacidade ", 8, _hoisted_14),
                      _cache[19] || (_cache[19] = _createTextVNode(". ", -1))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", _hoisted_16, _toDisplayString(_unref(t)("common.labels.register")?.toUpperCase()), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "back btn btn-sm btn-default",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (beforeStep()))
                  }, _toDisplayString(_unref(t)("common.labels.back")?.toUpperCase()), 1)
                ])
              ], 32)
            ], 64))
          : _createCommentVNode("", true),
        (step.value === 4)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("h2", null, _toDisplayString(_unref(t)("common.texts.register_account").toUpperCase()), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_unref(svgIcon), {
                    icon: "confirmed",
                    size: "2rem"
                  })
                ]),
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "subtitle" }, "Conta cadastrada com sucesso!", -1)),
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "description" }, " Verifique e-mail cadastrado para prosseguir com a ativação da sua conta. ", -1))
              ]),
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: goToLogin
              }, " Acessar minha conta ")
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})